import { IPharmacyAuthRepository } from '../interfaces';
import LogUtil from '../../../core/utils/LogUtil';

/**
 * PharmacyAuth Repository Implementation
 * 약국 인증 관리 API 호출 구현체
 */
export class PharmacyAuthRepositoryImpl extends IPharmacyAuthRepository {
  constructor(apiClient) {
    super();
    this.apiClient = apiClient;
    LogUtil.log('🔧 [PharmacyAuthRepository] 초기화 완료');
  }

  /**
   * 비밀번호 설정
   * POST /pharmacy/auth/set-password
   */
  async setPassword(data) {
    try {
      LogUtil.log('📤 [PharmacyAuthRepository] 비밀번호 설정 요청:', {
        business_registration_number: data.business_registration_number,
      });

      const response = await this.apiClient.post(
        '/pharmacy/auth/set-password',
        data
      );

      LogUtil.log('📥 [PharmacyAuthRepository] 비밀번호 설정 응답:', response);
      return response;
    } catch (error) {
      LogUtil.error('❌ [PharmacyAuthRepository] 비밀번호 설정 실패:', error);
      throw new Error(`비밀번호 설정 실패: ${error.message}`);
    }
  }

  /**
   * 로그인
   * POST /pharmacy/auth/login
   */
  async login(data) {
    try {
      LogUtil.log('📤 [PharmacyAuthRepository] 로그인 요청:', {
        business_registration_number: data.business_registration_number,
      });

      const response = await this.apiClient.post(
        '/pharmacy/auth/login',
        data
      );

      LogUtil.log('📥 [PharmacyAuthRepository] 로그인 응답:', response);
      return response;
    } catch (error) {
      LogUtil.error('❌ [PharmacyAuthRepository] 로그인 실패:', error);
      throw new Error(`로그인 실패: ${error.message}`);
    }
  }

  /**
   * 토큰 갱신
   * POST /pharmacy/auth/refresh
   */
  async refreshToken(data) {
    try {
      LogUtil.log('📤 [PharmacyAuthRepository] 토큰 갱신 요청');

      const response = await this.apiClient.post(
        '/pharmacy/auth/refresh',
        data
      );

      LogUtil.log('📥 [PharmacyAuthRepository] 토큰 갱신 응답:', response);
      return response;
    } catch (error) {
      LogUtil.error('❌ [PharmacyAuthRepository] 토큰 갱신 실패:', error);
      throw new Error(`토큰 갱신 실패: ${error.message}`);
    }
  }

  /**
   * 로그아웃
   * POST /pharmacy/auth/logout
   */
  async logout(data) {
    try {
      LogUtil.log('📤 [PharmacyAuthRepository] 로그아웃 요청');

      const response = await this.apiClient.post(
        '/pharmacy/auth/logout',
        data
      );

      LogUtil.log('📥 [PharmacyAuthRepository] 로그아웃 응답:', response);
      return response;
    } catch (error) {
      LogUtil.error('❌ [PharmacyAuthRepository] 로그아웃 실패:', error);
      throw new Error(`로그아웃 실패: ${error.message}`);
    }
  }
}
